export enum LocationPaths {
  AdminPanel = '/admin-panel',
  AllCompletedNotifications = '/admin-panel/all-completed-notifications',
  Coaches = '/coaches',
  ReplacementRequests = '/replacement-requests',
  Users = '/users',
  Login = '/login',
  ResetPasswordRequest = '/reset-password-request',
  NotFound = '/not-found',
  Surveys = '/surveys',
  Financials = '/financials',
  Knowledge = '/knowledge',
  SupportTickets = '/support-tickets',
  ChatbotMessageReports = '/chatbot-message-reports',
  AccountRequests = '/account-requests',
  Presentation = '/presentation',
  WebMembersPresentation = '/web-presentation',
  NutritionistHome = '/nutritionist-home',
  CoachCredentials = '/credentials',
  MembersManagement = '/members-management',
  NutritionistsOrganization = '/nutritionists-organization',
  CoachCredentialsReview = '/coach-credentials',
  OrganizationMembers = '/organization-members'
}

export interface ILocationState {
  from: ILocationStateFrom
}

export interface ILocationStateFrom {
  pathname: LocationPaths
}
